var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReplay10Outline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2929 2.29289C13.6834 1.90237 14.3166 1.90237 14.7071 2.29289C15.0976 2.68342 15.0976 3.31658 14.7071 3.70711L13.4071 5.00814C13.597 4.99739 13.8076 5 14 5C16.7611 5 19.2625 6.12038 21.0711 7.92893C22.8796 9.73748 24 12.2389 24 15C24 17.7611 22.8796 20.2625 21.0711 22.0711C19.2625 23.8796 16.7611 25 14 25C11.2389 25 8.73748 23.8796 6.92893 22.0711C5.12038 20.2625 4 17.7611 4 15C4 14.4477 4.44772 14 5 14C5.55228 14 6 14.4477 6 15C6 17.2094 6.89434 19.208 8.34315 20.6569C9.79196 22.1057 11.7906 23 14 23C16.2094 23 18.208 22.1057 19.6569 20.6569C21.1057 19.208 22 17.2094 22 15C22 12.7906 21.1057 10.792 19.6569 9.34315C18.208 7.89434 16.2094 7 14 7C13.8099 7 13.6215 7.00661 13.435 7.0196L14.7071 8.29289C15.0976 8.68342 15.0976 9.31658 14.7071 9.70711C14.3166 10.0976 13.6834 10.0976 13.2929 9.70711L10.2929 6.70711C9.90237 6.31658 9.90237 5.68342 10.2929 5.29289L13.2929 2.29289Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15.5C19.0037 12.868 17.7938 12 16.25 12C14.7062 12 13.5027 12.868 13.5 15.5C13.4973 18.132 14.7062 19 16.25 19C17.7938 19 18.9963 18.132 19 15.5ZM15.0973 15.5656C15.0973 14.0356 15.4779 13.5292 16.25 13.5292C17.0221 13.5292 17.4091 14.0349 17.4091 15.5656C17.4091 17.0962 17.029 17.6019 16.25 17.6019C15.471 17.6019 15.0973 17.0956 15.0973 15.5656Z",
    fill: "#023F80"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8046 19C10.5601 19 10.3619 18.8061 10.3619 18.5669V13.973L9.48368 14.3947C9.25133 14.484 9 14.3164 9 14.0722V13.4702C9 13.2962 9.10645 13.1391 9.27027 13.0713L11.3848 12.1057C11.6767 11.985 12 12.1946 12 12.5046V18.5669C12 18.8061 11.8018 19 11.5573 19H10.8046Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplay10Outline);
export default __webpack_public_path__ + "static/media/replay_10_outline.9a6af28e3af15feb46b229c07b0eafe3.svg";
export { ForwardRef as ReactComponent };